import React from "react";
import Page from "../../common/page/Page.js";
import LandingBlock from "./LandingBlock.js";

export default function LandingPage(props) {

  return (
    <Page className="LandingPage">
      <Page.Content className="spaced-children">
        <LandingBlock />
      </Page.Content>
    </Page>
  );
}
